import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClientGroupOptions } from '../redux/actions/clientGroups';
import { StoreState } from '../types/state';

const useClientGroupOptions = () => {
  const clientGroupOptions = useSelector((state: StoreState) => {
    return state.clients.clientGroupOptions;
  });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!clientGroupOptions) {
      dispatch(getClientGroupOptions());
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [clientGroupOptions, dispatch]);

  return { clientGroupOptions, isLoading };
};

export default useClientGroupOptions;
